import settings from 'src/core/config/hostConfig'

export const isCoreServiceAvailable = () => {
  return !!settings.identityService
}

export const isSBServiceAvailable = () => {
  return !!settings.sitebuilderService
}

export const isChatMessagesAvailable = () => {
  return !!settings.chatMessageService
}

// Read/write dropdown LOV from the configured LOV service (`/v1/lov`) when its
// URL is set. Absent in other apps' config (-> undefined -> false), so they
// keep their existing sitebuilder/form-storage behavior.
export const isLovServiceAvailable = () => {
  return !!settings.lovService
}
